import { apiRequest } from "@/lib/api-client";

import type { AuthUser } from "./types";

export function login(email: string, password: string) {
  return apiRequest<AuthUser>("/auth/login", {
    method: "POST",
    body: JSON.stringify({ email, password })
  });
}

export function logout() {
  return apiRequest<null>("/auth/logout", { method: "POST" });
}

export function getCurrentUser() {
  return apiRequest<AuthUser>("/auth/me");
}
